import React from 'react';
import Icon from '../../../components/AppIcon';

const FieldTemplatesLibrary = ({ onTemplateClick }) => {
  const fieldTemplates = [
    {
      id: 'contact-info',
      name: 'Contact Information',
      icon: 'User',
      description: 'Full name, email, and phone number',
      fields: [
        {
          id: 'text',
          name: 'Full Name',
          icon: 'User',
          type: 'input',
          label: 'Full Name',
          placeholder: 'Enter your full name...',
          required: true
        },
        {
          id: 'email',
          name: 'Email Address',
          icon: 'Mail',
          type: 'input',
          label: 'Email Address',
          placeholder: 'Enter your email...',
          required: true
        },
        {
          id: 'phone',
          name: 'Phone Number',
          icon: 'Phone',
          type: 'input',
          label: 'Phone Number',
          placeholder: 'Enter your phone number...',
          required: false
        }
      ]
    },
    {
      id: 'address-block',
      name: 'Address Block',
      icon: 'MapPin',
      description: 'Complete address with street, city, state, and zip',
      fields: [
        {
          id: 'text',
          name: 'Street Address',
          icon: 'Home',
          type: 'input',
          label: 'Street Address',
          placeholder: 'Enter street address...',
          required: true
        },
        {
          id: 'text',
          name: 'City',
          icon: 'MapPin',
          type: 'input',
          label: 'City',
          placeholder: 'Enter city...',
          required: true
        },
        {
          id: 'text',
          name: 'State/Province',
          icon: 'Map',
          type: 'input',
          label: 'State/Province',
          placeholder: 'Enter state or province...',
          required: true
        },
        {
          id: 'text',
          name: 'Zip/Postal Code',
          icon: 'Hash',
          type: 'input',
          label: 'Zip/Postal Code',
          placeholder: 'Enter zip or postal code...',
          required: true
        },
        {
          id: 'dropdown',
          name: 'Country',
          icon: 'Globe',
          type: 'select',
          label: 'Country',
          placeholder: 'Select country...',
          required: true,
          options: ['United States', 'Canada', 'United Kingdom', 'Australia', 'Other']
        }
      ]
    },
    {
      id: 'billing-address',
      name: 'Billing Address',
      icon: 'CreditCard',
      description: 'Billing address for payment processing',
      fields: [
        {
          id: 'text',
          name: 'Billing Street Address',
          icon: 'Home',
          type: 'input',
          label: 'Billing Street Address',
          placeholder: 'Enter billing street address...',
          required: true
        },
        {
          id: 'text',
          name: 'Billing City',
          icon: 'MapPin',
          type: 'input',
          label: 'Billing City',
          placeholder: 'Enter billing city...',
          required: true
        },
        {
          id: 'text',
          name: 'Billing State',
          icon: 'Map',
          type: 'input',
          label: 'Billing State',
          placeholder: 'Enter billing state...',
          required: true
        },
        {
          id: 'text',
          name: 'Billing Zip Code',
          icon: 'Hash',
          type: 'input',
          label: 'Billing Zip Code',
          placeholder: 'Enter billing zip code...',
          required: true
        }
      ]
    },
    {
      id: 'consent-gdpr',
      name: 'GDPR Consent',
      icon: 'Shield',
      description: 'Consent checkbox to support GDPR workflows',
      fields: [
        {
          id: 'checkbox',
          name: 'GDPR Consent',
          icon: 'CheckSquare',
          type: 'checkbox',
          label: 'I agree to the processing of my personal data',
          placeholder: '',
          required: true,
          options: ['I consent to the collection and processing of my personal data in accordance with the Privacy Policy']
        }
      ]
    },
    {
      id: 'consent-marketing',
      name: 'Marketing Consent',
      icon: 'Mail',
      description: 'Marketing communications opt-in',
      fields: [
        {
          id: 'checkbox',
          name: 'Marketing Consent',
          icon: 'CheckSquare',
          type: 'checkbox',
          label: 'Marketing Communications',
          placeholder: '',
          required: false,
          options: [
            'I would like to receive marketing emails and promotional offers',
            'I agree to receive SMS notifications about special offers'
          ]
        }
      ]
    },
    {
      id: 'consent-terms',
      name: 'Terms & Conditions',
      icon: 'FileText',
      description: 'Terms of service acceptance',
      fields: [
        {
          id: 'checkbox',
          name: 'Terms Acceptance',
          icon: 'CheckSquare',
          type: 'checkbox',
          label: 'Terms and Conditions',
          placeholder: '',
          required: true,
          options: ['I have read and agree to the Terms of Service and Privacy Policy']
        }
      ]
    },
    {
      id: 'emergency-contact',
      name: 'Emergency Contact',
      icon: 'AlertCircle',
      description: 'Emergency contact information',
      fields: [
        {
          id: 'text',
          name: 'Emergency Contact Name',
          icon: 'User',
          type: 'input',
          label: 'Emergency Contact Name',
          placeholder: 'Enter emergency contact name...',
          required: true
        },
        {
          id: 'phone',
          name: 'Emergency Contact Phone',
          icon: 'Phone',
          type: 'input',
          label: 'Emergency Contact Phone',
          placeholder: 'Enter emergency contact phone...',
          required: true
        },
        {
          id: 'dropdown',
          name: 'Relationship',
          icon: 'Users',
          type: 'select',
          label: 'Relationship',
          placeholder: 'Select relationship...',
          required: true,
          options: ['Spouse', 'Parent', 'Sibling', 'Friend', 'Other']
        }
      ]
    },
    {
      id: 'business-info',
      name: 'Business Information',
      icon: 'Briefcase',
      description: 'Company name, title, and website',
      fields: [
        {
          id: 'text',
          name: 'Company Name',
          icon: 'Briefcase',
          type: 'input',
          label: 'Company Name',
          placeholder: 'Enter company name...',
          required: true
        },
        {
          id: 'text',
          name: 'Job Title',
          icon: 'User',
          type: 'input',
          label: 'Job Title',
          placeholder: 'Enter job title...',
          required: false
        },
        {
          id: 'url',
          name: 'Company Website',
          icon: 'Link',
          type: 'input',
          label: 'Company Website',
          placeholder: 'Enter company website...',
          required: false
        }
      ]
    },
    {
      id: 'social-media',
      name: 'Social Media Links',
      icon: 'Share2',
      description: 'Social media profile links',
      fields: [
        {
          id: 'url',
          name: 'LinkedIn Profile',
          icon: 'Linkedin',
          type: 'input',
          label: 'LinkedIn Profile',
          placeholder: 'Enter LinkedIn URL...',
          required: false
        },
        {
          id: 'url',
          name: 'Twitter Profile',
          icon: 'Twitter',
          type: 'input',
          label: 'Twitter Profile',
          placeholder: 'Enter Twitter URL...',
          required: false
        },
        {
          id: 'url',
          name: 'Facebook Profile',
          icon: 'Facebook',
          type: 'input',
          label: 'Facebook Profile',
          placeholder: 'Enter Facebook URL...',
          required: false
        }
      ]
    },
    {
      id: 'a2p-verification',
      name: 'A2P Verification',
      icon: 'MessageSquare',
      description: 'SMS consent for non-marketing text messages',
      fields: [
        {
          id: 'checkbox',
          name: 'A2P SMS Consent',
          icon: 'CheckSquare',
          type: 'checkbox',
          label: 'A2P Verification',
          placeholder: '',
          required: true,
          options: [
            'I consent to receive non-marketing text messages from {company name here} about my order updates, appointment reminders etc. Message & data rates may apply. Text HELP for assistance, reply STOP to opt out.'
          ]
        }
      ]
    },
    {
      id: 'payment-info',
      name: 'Payment Information',
      icon: 'DollarSign',
      description: 'Basic payment details (non-sensitive)',
      fields: [
        {
          id: 'dropdown',
          name: 'Payment Method',
          icon: 'CreditCard',
          type: 'select',
          label: 'Payment Method',
          placeholder: 'Select payment method...',
          required: true,
          options: ['Credit Card', 'Debit Card', 'PayPal', 'Bank Transfer', 'Other']
        },
        {
          id: 'text',
          name: 'Billing Name',
          icon: 'User',
          type: 'input',
          label: 'Name on Card',
          placeholder: 'Enter name as it appears on card...',
          required: true
        }
      ]
    }
  ];

  const handleTemplateClick = (template) => {
    if (onTemplateClick) {
      onTemplateClick(template);
    }
  };

  return (
    <div className="flex-1 overflow-y-auto scrollbar-custom p-4">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-foreground mb-1">Field Templates</h3>
        <p className="text-xs text-muted-foreground">
          Add multiple related fields at once for faster form building
        </p>
      </div>
      
      <div className="space-y-2">
        {fieldTemplates?.map((template) => (
          <div
            key={template?.id}
            onClick={() => handleTemplateClick(template)}
            className="
              px-2.5 py-2 bg-muted/50 rounded-md transition-smooth border border-transparent
              hover:border-border cursor-pointer hover:bg-primary/10 hover:shadow-elevation-sm
            "
          >
            <div className="flex items-center gap-2.5">
              <div className="w-7 h-7 bg-primary/10 rounded-md flex items-center justify-center flex-shrink-0">
                <Icon name={template?.icon} size={14} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-semibold text-foreground leading-tight">
                    {template?.name}
                  </span>
                  <span className="text-xs text-muted-foreground bg-muted px-1.5 py-0.5 rounded">
                    {template?.fields?.length}
                  </span>
                </div>
                <p className="text-xs text-muted-foreground leading-tight truncate">
                  {template?.description}
                </p>
              </div>
              <Icon name="Plus" size={14} color="var(--color-primary)" className="flex-shrink-0" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FieldTemplatesLibrary;